module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_1.2e9a423f.png";